import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combines and merges CSS class names using clsx and Tailwind CSS merge functionality.
 *
 * @param {...(string|string[]|Object.<string, boolean>|undefined|null|false)} inputs - Variable number of class values that can be strings, arrays of strings, objects with boolean values, or falsy values
 * @returns {string} A merged and deduplicated string of CSS class names
 *
 * @example
 * // Basic usage
 * cn('btn', 'btn-primary') // Returns: 'btn btn-primary'
 *
 * @example
 * // With conditional classes
 * cn('btn', { 'btn-active': isActive }, 'px-4') // Returns: 'btn px-4' or 'btn btn-active px-4'
 *
 * @example
 * // With Tailwind merge (conflicting classes)
 * cn('p-4', 'p-6') // Returns: 'p-6' (later padding wins)
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
